
<div class="box flex flex-column align-items-center position-center padding-md">

    <img class="img-xl margin-bottom-sm" src="http://dpzaq1wj21co3.cloudfront.net/uv-logo.svg">

    <h3 class="margin-bottom-sm">Welcome to UV</h3>

    <uvx-button mode='primary' color='primary' label="Login" (click)="login()"></uvx-button>

    <!-- <div class="padding-sm flex flex-column gap-10">
        <div *ngFor="let icon of newIcons" class="flex justify-content-space-between">
            <div class="flex gap-10">
                <uvx-icon [icon]="icon.name"></uvx-icon> 
                <p>{{icon.name}}</p>
            </div>
            <p>{{icon.url}}</p>
        </div>
    </div> -->

</div>
